import { Loader2 } from 'lucide-react';

export function KpiTile({ label, value, hint, accent = 'text-white', testid }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-4" data-testid={testid}>
      <div className="text-[11px] text-white/50">{label}</div>
      <div className={`text-2xl font-bold mt-1 ${accent}`} dir="ltr">{value}</div>
      {hint && <div className="text-[10px] text-white/40 mt-0.5">{hint}</div>}
    </div>
  );
}

export function RankList({ title, items, emptyText, onPick, accent = 'bg-sky-500/60', testid, renderExtra }) {
  const max = Math.max(1, ...items.map((i) => i.count));
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-4" data-testid={testid}>
      <div className="text-sm font-bold text-white mb-3">{title}</div>
      {items.length === 0 ? (
        <div className="text-xs text-white/30 py-6 text-center">{emptyText}</div>
      ) : (
        <ul className="space-y-1.5">
          {items.map((i) => (
            <li key={i.key}>
              <button type="button" onClick={() => onPick && onPick(i.key)}
                      className="w-full text-start group" disabled={!onPick}>
                <div className="flex items-center justify-between text-xs gap-2">
                  <span className="text-white/85 truncate group-hover:text-white" dir="auto">{i.key}</span>
                  <span className="text-white/50 font-mono shrink-0">{i.count}{renderExtra ? renderExtra(i) : ''}</span>
                </div>
                <div className="h-1 rounded bg-white/5 mt-1 overflow-hidden">
                  <div className={`h-full ${accent}`} style={{ width: `${(i.count / max) * 100}%` }} />
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function HourlyBars({ title, hours, t }) {
  const max = Math.max(1, ...hours);
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-4" data-testid="search-hourly">
      <div className="text-sm font-bold text-white mb-3">{title}</div>
      <div className="flex items-end gap-[3px] h-24" dir="ltr">
        {hours.map((c, h) => (
          <div key={h} className="flex-1 flex flex-col items-center justify-end h-full" title={`${h}:00 — ${c}`}>
            <div className="w-full rounded-t bg-[#d4af37]/70 hover:bg-[#d4af37]" style={{ height: `${Math.max(2, (c / max) * 100)}%` }} />
          </div>
        ))}
      </div>
      <div className="flex justify-between text-[9px] text-white/30 mt-1" dir="ltr"><span>00</span><span>06</span><span>12</span><span>18</span><span>23</span></div>
      <div className="text-[10px] text-white/40 mt-1">{t('بتوقيت دبي', 'Dubai time')}</div>
    </div>
  );
}

export function LoadingBlock() {
  return <div className="flex justify-center py-16 text-white/40"><Loader2 className="w-7 h-7 animate-spin" /></div>;
}
